const startingState = {
  date: "2022-06-08",
  date_epoch: 1654646400,
  day: {
    maxtemp_c: 46.2,
    maxtemp_f: 115.2,
    mintemp_c: 27.1,
    mintemp_f: 80.8,
    avgtemp_c: 35.5,
    avgtemp_f: 95.9,
    maxwind_mph: 9.8,
    maxwind_kph: 15.8,
    totalprecip_mm: 0,
    totalprecip_in: 0,
    avgvis_km: 10,
    avgvis_miles: 6,
    avghumidity: 12,
    daily_will_it_rain: 0,
    daily_chance_of_rain: 0,
    daily_will_it_snow: 0,
    daily_chance_of_snow: 0,
    condition: {
      text: "Sunny",
      icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
      code: 1000,
    },
    uv: 11,
  },
  astro: {
    sunrise: "05:19 AM",
    sunset: "07:26 PM",
    moonrise: "12:54 PM",
    moonset: "01:07 AM",
    moon_phase: "First Quarter",
    moon_illumination: "61",
  },
  hour: [
    {
      time_epoch: 1654626600,
      time: "2022-06-08 00:00",
      temp_c: 28.1,
      temp_f: 82.6,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 6.5,
      wind_kph: 10.4,
      wind_degree: 81,
      wind_dir: "E",
      pressure_mb: 999,
      pressure_in: 29.49,
      precip_mm: 0,
      precip_in: 0,
      humidity: 14,
      cloud: 6,
      feelslike_c: 26.1,
      feelslike_f: 79,
      windchill_c: 28.1,
      windchill_f: 82.6,
      heatindex_c: 26.1,
      heatindex_f: 79,
      dewpoint_c: -1.5,
      dewpoint_f: 29.3,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 13.6,
      gust_kph: 22,
      uv: 1,
    },
    {
      time_epoch: 1654630200,
      time: "2022-06-08 01:00",
      temp_c: 27.6,
      temp_f: 81.7,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 6,
      wind_kph: 9.7,
      wind_degree: 73,
      wind_dir: "ENE",
      pressure_mb: 998,
      pressure_in: 29.48,
      precip_mm: 0,
      precip_in: 0,
      humidity: 15,
      cloud: 6,
      feelslike_c: 25.7,
      feelslike_f: 78.3,
      windchill_c: 27.6,
      windchill_f: 81.7,
      heatindex_c: 25.7,
      heatindex_f: 78.3,
      dewpoint_c: -1.2,
      dewpoint_f: 29.8,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 12.8,
      gust_kph: 20.5,
      uv: 1,
    },
    {
      time_epoch: 1654633800,
      time: "2022-06-08 02:00",
      temp_c: 28.4,
      temp_f: 83.1,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 5.6,
      wind_kph: 9,
      wind_degree: 75,
      wind_dir: "ENE",
      pressure_mb: 999,
      pressure_in: 29.49,
      precip_mm: 0,
      precip_in: 0,
      humidity: 17,
      cloud: 10,
      feelslike_c: 26.4,
      feelslike_f: 79.5,
      windchill_c: 28.4,
      windchill_f: 83.1,
      heatindex_c: 26.4,
      heatindex_f: 79.5,
      dewpoint_c: 1.4,
      dewpoint_f: 34.5,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 11.6,
      gust_kph: 18.7,
      uv: 1,
    },
    {
      time_epoch: 1654637400,
      time: "2022-06-08 03:00",
      temp_c: 27.9,
      temp_f: 82.2,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 5.8,
      wind_kph: 9.4,
      wind_degree: 74,
      wind_dir: "ENE",
      pressure_mb: 999,
      pressure_in: 29.49,
      precip_mm: 0,
      precip_in: 0,
      humidity: 18,
      cloud: 9,
      feelslike_c: 25.9,
      feelslike_f: 78.6,
      windchill_c: 27.9,
      windchill_f: 82.2,
      heatindex_c: 25.9,
      heatindex_f: 78.6,
      dewpoint_c: 1.5,
      dewpoint_f: 34.7,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 12.3,
      gust_kph: 19.8,
      uv: 1,
    },
    {
      time_epoch: 1654641000,
      time: "2022-06-08 04:00",
      temp_c: 27.4,
      temp_f: 81.3,
      is_day: 0,
      condition: {
        text: "Clear",
        icon: "//cdn.weatherapi.com/weather/64x64/night/113.png",
        code: 1000,
      },
      wind_mph: 5.6,
      wind_kph: 9,
      wind_degree: 82,
      wind_dir: "E",
      pressure_mb: 999,
      pressure_in: 29.51,
      precip_mm: 0,
      precip_in: 0,
      humidity: 19,
      cloud: 17,
      feelslike_c: 25.5,
      feelslike_f: 77.9,
      windchill_c: 27.4,
      windchill_f: 81.3,
      heatindex_c: 25.5,
      heatindex_f: 77.9,
      dewpoint_c: 1.7,
      dewpoint_f: 35.1,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 11.6,
      gust_kph: 18.7,
      uv: 1,
    },
    {
      time_epoch: 1654644600,
      time: "2022-06-08 05:00",
      temp_c: 27.1,
      temp_f: 80.8,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 5.1,
      wind_kph: 8.3,
      wind_degree: 88,
      wind_dir: "E",
      pressure_mb: 1000,
      pressure_in: 29.54,
      precip_mm: 0,
      precip_in: 0,
      humidity: 19,
      cloud: 19,
      feelslike_c: 25.3,
      feelslike_f: 77.5,
      windchill_c: 27.1,
      windchill_f: 80.8,
      heatindex_c: 25.3,
      heatindex_f: 77.5,
      dewpoint_c: 1.7,
      dewpoint_f: 35.1,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 10.7,
      gust_kph: 17.3,
      uv: 7,
    },
    {
      time_epoch: 1654648200,
      time: "2022-06-08 06:00",
      temp_c: 29,
      temp_f: 84.2,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 5.8,
      wind_kph: 9.4,
      wind_degree: 98,
      wind_dir: "E",
      pressure_mb: 1001,
      pressure_in: 29.56,
      precip_mm: 0,
      precip_in: 0,
      humidity: 18,
      cloud: 13,
      feelslike_c: 26.9,
      feelslike_f: 80.4,
      windchill_c: 29,
      windchill_f: 84.2,
      heatindex_c: 26.9,
      heatindex_f: 80.4,
      dewpoint_c: 2.4,
      dewpoint_f: 36.3,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 10.7,
      gust_kph: 17.3,
      uv: 7,
    },
    {
      time_epoch: 1654651800,
      time: "2022-06-08 07:00",
      temp_c: 33.1,
      temp_f: 91.6,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 6.3,
      wind_kph: 10.1,
      wind_degree: 137,
      wind_dir: "SE",
      pressure_mb: 1001,
      pressure_in: 29.57,
      precip_mm: 0,
      precip_in: 0,
      humidity: 14,
      cloud: 11,
      feelslike_c: 31,
      feelslike_f: 87.8,
      windchill_c: 33.1,
      windchill_f: 91.6,
      heatindex_c: 31,
      heatindex_f: 87.8,
      dewpoint_c: 2.4,
      dewpoint_f: 36.3,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 7.2,
      gust_kph: 11.5,
      uv: 8,
    },
    {
      time_epoch: 1654655400,
      time: "2022-06-08 08:00",
      temp_c: 35.9,
      temp_f: 96.6,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 8.9,
      wind_kph: 14.4,
      wind_degree: 171,
      wind_dir: "S",
      pressure_mb: 1001,
      pressure_in: 29.55,
      precip_mm: 0,
      precip_in: 0,
      humidity: 12,
      cloud: 4,
      feelslike_c: 34.3,
      feelslike_f: 93.7,
      windchill_c: 35.9,
      windchill_f: 96.6,
      heatindex_c: 34.3,
      heatindex_f: 93.7,
      dewpoint_c: 2.5,
      dewpoint_f: 36.5,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 10.3,
      gust_kph: 16.6,
      uv: 9,
    },
    {
      time_epoch: 1654659000,
      time: "2022-06-08 09:00",
      temp_c: 37.7,
      temp_f: 99.9,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 8.1,
      wind_kph: 13,
      wind_degree: 198,
      wind_dir: "SSW",
      pressure_mb: 1001,
      pressure_in: 29.55,
      precip_mm: 0,
      precip_in: 0,
      humidity: 12,
      cloud: 4,
      feelslike_c: 36.6,
      feelslike_f: 97.9,
      windchill_c: 37.7,
      windchill_f: 99.9,
      heatindex_c: 36.6,
      heatindex_f: 97.9,
      dewpoint_c: 2.9,
      dewpoint_f: 37.2,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 9.2,
      gust_kph: 14.8,
      uv: 9,
    },
    {
      time_epoch: 1654662600,
      time: "2022-06-08 10:00",
      temp_c: 39.1,
      temp_f: 102.4,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 8.5,
      wind_kph: 13.7,
      wind_degree: 212,
      wind_dir: "SSW",
      pressure_mb: 1000,
      pressure_in: 29.54,
      precip_mm: 0,
      precip_in: 0,
      humidity: 11,
      cloud: 2,
      feelslike_c: 38.6,
      feelslike_f: 101.5,
      windchill_c: 39.1,
      windchill_f: 102.4,
      heatindex_c: 38.6,
      heatindex_f: 101.5,
      dewpoint_c: 3.2,
      dewpoint_f: 37.8,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 9.8,
      gust_kph: 15.8,
      uv: 9,
    },
    {
      time_epoch: 1654666200,
      time: "2022-06-08 11:00",
      temp_c: 43.5,
      temp_f: 110.3,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 7.8,
      wind_kph: 12.6,
      wind_degree: 230,
      wind_dir: "SW",
      pressure_mb: 999,
      pressure_in: 29.51,
      precip_mm: 0,
      precip_in: 0,
      humidity: 10,
      cloud: 0,
      feelslike_c: 45.4,
      feelslike_f: 113.7,
      windchill_c: 43.5,
      windchill_f: 110.3,
      heatindex_c: 45.4,
      heatindex_f: 113.7,
      dewpoint_c: 5.4,
      dewpoint_f: 41.7,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.9,
      gust_kph: 14.4,
      uv: 10,
    },
    {
      time_epoch: 1654669800,
      time: "2022-06-08 12:00",
      temp_c: 44.7,
      temp_f: 112.5,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 7.6,
      wind_kph: 12.2,
      wind_degree: 249,
      wind_dir: "WSW",
      pressure_mb: 998,
      pressure_in: 29.47,
      precip_mm: 0,
      precip_in: 0,
      humidity: 9,
      cloud: 0,
      feelslike_c: 47.4,
      feelslike_f: 117.3,
      windchill_c: 44.7,
      windchill_f: 112.5,
      heatindex_c: 47.4,
      heatindex_f: 117.3,
      dewpoint_c: 4.5,
      dewpoint_f: 40.1,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.7,
      gust_kph: 14,
      uv: 10,
    },
    {
      time_epoch: 1654673400,
      time: "2022-06-08 13:00",
      temp_c: 45.7,
      temp_f: 114.3,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 6.9,
      wind_kph: 11.2,
      wind_degree: 272,
      wind_dir: "W",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 8,
      cloud: 0,
      feelslike_c: 49.2,
      feelslike_f: 120.6,
      windchill_c: 45.7,
      windchill_f: 114.3,
      heatindex_c: 49.2,
      heatindex_f: 120.6,
      dewpoint_c: 3.3,
      dewpoint_f: 37.9,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.1,
      gust_kph: 13,
      uv: 11,
    },
    {
      time_epoch: 1654677000,
      time: "2022-06-08 14:00",
      temp_c: 46.2,
      temp_f: 115.2,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 6.9,
      wind_kph: 11.2,
      wind_degree: 277,
      wind_dir: "W",
      pressure_mb: 996,
      pressure_in: 29.4,
      precip_mm: 0,
      precip_in: 0,
      humidity: 7,
      cloud: 5,
      feelslike_c: 50.1,
      feelslike_f: 122.2,
      windchill_c: 46.2,
      windchill_f: 115.2,
      heatindex_c: 50.1,
      heatindex_f: 122.2,
      dewpoint_c: 2.5,
      dewpoint_f: 36.5,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.1,
      gust_kph: 13,
      uv: 11,
    },
    {
      time_epoch: 1654680600,
      time: "2022-06-08 15:00",
      temp_c: 44,
      temp_f: 111.2,
      is_day: 1,
      condition: {
        text: "Sunny",
        icon: "//cdn.weatherapi.com/weather/64x64/day/113.png",
        code: 1000,
      },
      wind_mph: 7.6,
      wind_kph: 12.2,
      wind_degree: 275,
      wind_dir: "W",
      pressure_mb: 995,
      pressure_in: 29.37,
      precip_mm: 0,
      precip_in: 0,
      humidity: 7,
      cloud: 22,
      feelslike_c: 46.2,
      feelslike_f: 115.2,
      windchill_c: 44,
      windchill_f: 111.2,
      heatindex_c: 46.2,
      heatindex_f: 115.2,
      dewpoint_c: 0.4,
      dewpoint_f: 32.7,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.7,
      gust_kph: 14,
      uv: 10,
    },
    {
      time_epoch: 1654684200,
      time: "2022-06-08 16:00",
      temp_c: 42.6,
      temp_f: 108.7,
      is_day: 1,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
        code: 1003,
      },
      wind_mph: 8.3,
      wind_kph: 13.3,
      wind_degree: 271,
      wind_dir: "W",
      pressure_mb: 994,
      pressure_in: 29.35,
      precip_mm: 0,
      precip_in: 0,
      humidity: 7,
      cloud: 40,
      feelslike_c: 43.9,
      feelslike_f: 111,
      windchill_c: 42.6,
      windchill_f: 108.7,
      heatindex_c: 43.9,
      heatindex_f: 111,
      dewpoint_c: -0.9,
      dewpoint_f: 30.4,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 9.6,
      gust_kph: 15.5,
      uv: 10,
    },
    {
      time_epoch: 1654687800,
      time: "2022-06-08 17:00",
      temp_c: 41.6,
      temp_f: 106.9,
      is_day: 1,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/day/116.png",
        code: 1003,
      },
      wind_mph: 9.8,
      wind_kph: 15.8,
      wind_degree: 273,
      wind_dir: "W",
      pressure_mb: 994,
      pressure_in: 29.34,
      precip_mm: 0,
      precip_in: 0,
      humidity: 7,
      cloud: 44,
      feelslike_c: 42.3,
      feelslike_f: 108.1,
      windchill_c: 41.6,
      windchill_f: 106.9,
      heatindex_c: 42.3,
      heatindex_f: 108.1,
      dewpoint_c: -1.4,
      dewpoint_f: 29.5,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 11.4,
      gust_kph: 18.4,
      uv: 10,
    },
    {
      time_epoch: 1654691400,
      time: "2022-06-08 18:00",
      temp_c: 39.9,
      temp_f: 103.8,
      is_day: 1,
      condition: {
        text: "Cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/day/119.png",
        code: 1006,
      },
      wind_mph: 8.1,
      wind_kph: 13,
      wind_degree: 279,
      wind_dir: "W",
      pressure_mb: 994,
      pressure_in: 29.35,
      precip_mm: 0,
      precip_in: 0,
      humidity: 8,
      cloud: 72,
      feelslike_c: 39.8,
      feelslike_f: 103.6,
      windchill_c: 39.9,
      windchill_f: 103.8,
      heatindex_c: 39.8,
      heatindex_f: 103.6,
      dewpoint_c: -0.9,
      dewpoint_f: 30.4,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 12.5,
      gust_kph: 20.2,
      uv: 8,
    },
    {
      time_epoch: 1654695000,
      time: "2022-06-08 19:00",
      temp_c: 35,
      temp_f: 95,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 2.9,
      wind_kph: 4.7,
      wind_degree: 284,
      wind_dir: "WNW",
      pressure_mb: 995,
      pressure_in: 29.37,
      precip_mm: 0,
      precip_in: 0,
      humidity: 10,
      cloud: 50,
      feelslike_c: 33.2,
      feelslike_f: 91.8,
      windchill_c: 35,
      windchill_f: 95,
      heatindex_c: 33.2,
      heatindex_f: 91.8,
      dewpoint_c: -0.9,
      dewpoint_f: 30.4,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 6,
      gust_kph: 9.7,
      uv: 1,
    },
    {
      time_epoch: 1654698600,
      time: "2022-06-08 20:00",
      temp_c: 33.5,
      temp_f: 92.3,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 0.9,
      wind_kph: 1.4,
      wind_degree: 50,
      wind_dir: "NE",
      pressure_mb: 995,
      pressure_in: 29.39,
      precip_mm: 0,
      precip_in: 0,
      humidity: 11,
      cloud: 39,
      feelslike_c: 31.4,
      feelslike_f: 88.5,
      windchill_c: 33.5,
      windchill_f: 92.3,
      heatindex_c: 31.4,
      heatindex_f: 88.5,
      dewpoint_c: -0.8,
      dewpoint_f: 30.6,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 1.8,
      gust_kph: 2.9,
      uv: 1,
    },
    {
      time_epoch: 1654702200,
      time: "2022-06-08 21:00",
      temp_c: 32.2,
      temp_f: 90,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 4,
      wind_kph: 6.5,
      wind_degree: 82,
      wind_dir: "E",
      pressure_mb: 996,
      pressure_in: 29.42,
      precip_mm: 0,
      precip_in: 0,
      humidity: 12,
      cloud: 29,
      feelslike_c: 30,
      feelslike_f: 86,
      windchill_c: 32.2,
      windchill_f: 90,
      heatindex_c: 30,
      heatindex_f: 86,
      dewpoint_c: -0.8,
      dewpoint_f: 30.6,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 8.5,
      gust_kph: 13.7,
      uv: 1,
    },
    {
      time_epoch: 1654705800,
      time: "2022-06-08 22:00",
      temp_c: 30.9,
      temp_f: 87.6,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 5.6,
      wind_kph: 9,
      wind_degree: 97,
      wind_dir: "E",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 13,
      cloud: 40,
      feelslike_c: 28.7,
      feelslike_f: 83.7,
      windchill_c: 30.9,
      windchill_f: 87.6,
      heatindex_c: 28.7,
      heatindex_f: 83.7,
      dewpoint_c: -0.6,
      dewpoint_f: 30.9,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 11.6,
      gust_kph: 18.7,
      uv: 1,
    },
    {
      time_epoch: 1654709400,
      time: "2022-06-08 23:00",
      temp_c: 30.3,
      temp_f: 86.5,
      is_day: 0,
      condition: {
        text: "Partly cloudy",
        icon: "//cdn.weatherapi.com/weather/64x64/night/116.png",
        code: 1003,
      },
      wind_mph: 8.1,
      wind_kph: 13,
      wind_degree: 117,
      wind_dir: "ESE",
      pressure_mb: 997,
      pressure_in: 29.44,
      precip_mm: 0,
      precip_in: 0,
      humidity: 14,
      cloud: 31,
      feelslike_c: 28.1,
      feelslike_f: 82.6,
      windchill_c: 30.3,
      windchill_f: 86.5,
      heatindex_c: 28.1,
      heatindex_f: 82.6,
      dewpoint_c: 0.1,
      dewpoint_f: 32.2,
      will_it_rain: 0,
      chance_of_rain: 0,
      will_it_snow: 0,
      chance_of_snow: 0,
      vis_km: 10,
      vis_miles: 6,
      gust_mph: 17,
      gust_kph: 27.4,
      uv: 1,
    },
  ],
};
const selectedDateReducer = (state = startingState, action) => {
  switch (action.type) {
    case "SELECTED":
      return action.value;
    default:
      return state;
  }
};

export default selectedDateReducer;
